const constants = Object.freeze({
    BOT_FAVORITE_SIDE_HOME_TEAM_ID: 1,
    BOT_FAVORITE_SIDE_AWAY_TEAM_ID: 2,

    BET_TYPE_HANDICAP: 1,
    BET_TYPE_GOAL: 2,
    BET_TYPE_1X2: 3,
    BET_TYPE_BTTS: 4,
    BET_TYPE_DC: 5,
    BET_TYPE_CS: 6,
    BET_TYPE_CORNERS_HANDICAP: 7,
    BET_TYPE_CORNERS_GOAL: 8,
    BET_TYPE_HANDICAP_JOLLY: 'J',
    BET_TYPE_HANDICAP_DOG: 'D',
    BET_TYPE_CORNERS_HANDICAP_JOLLY: 'CJ',
    BET_TYPE_CORNERS_HANDICAP_DOG: 'CD',
    BET_TYPE_GOAL_OVER: 'O',
    BET_TYPE_GOAL_UNDER: 'U',
    BET_TYPE_CORNERS_GOAL_OVER: 'CO',
    BET_TYPE_CORNERS_GOAL_UNDER: 'CU',
    BET_TYPE_1X2_HOME: '1',
    BET_TYPE_1X2_AWAY: '2',
    BET_TYPE_1X2_DRAW: 'X',
    BET_TYPE_BTTS_YES: 'Y',
    BET_TYPE_BTTS_NO: 'N',
    BET_TYPE_DC_HOME_OR_DRAW: '1X',
    BET_TYPE_DC_DRAW_OR_AWAY: 'X2',
    BET_TYPE_DC_HOME_OR_AWAY: '12',
    BET_TYPE_CS_CS: 'CS',

    BET_SELECTION_TEAM_HOME: 1,
    BET_SELECTION_TEAM_AWAY: 2,
    BET_SELECTION_TEAM_OVER: 3,
    BET_SELECTION_TEAM_UNDER: 4,
    BET_SELECTION_TEAM_ONE: 5,
    BET_SELECTION_TEAM_X: 6,
    BET_SELECTION_TEAM_TWO: 7,
    BET_SELECTION_YES: 8,
    BET_SELECTION_NO: 9,
    BET_SELECTION_TEAM_1X: 10,
    BET_SELECTION_TEAM_12: 11,
    BET_SELECTION_TEAM_X2: 12,
    BET_SELECTION_CS: 13,
    BET_SELECTION_CORNERS_TEAM_HOME: 14,
    BET_SELECTION_CORNERS_TEAM_AWAY: 15,
    BET_SELECTION_CORNERS_TEAM_OVER: 16,
    BET_SELECTION_CORNERS_TEAM_UNDER: 17,

    BET_MARKET_TYPE_1X2: 1,
    BET_MARKET_TYPE_HANDICAP: 2,
    BET_MARKET_TYPE_GOAL: 3,
    BET_MARKET_TYPE_BTTS: 4,
    BET_MARKET_TYPE_DC: 5,
    BET_MARKET_TYPE_CS: 6,

    BET_STATUS_RUN: 1,
    BET_STATUS_WAIT: 2,
    BET_STATUS_SET: 3,
    BET_STATUS_REJ: 6,
    BET_STATUS_REF: 13,
    BET_STATUS_SUSP: 14,
    BET_STATUS_FAKE: 50,
    BET_STATUS_VOID: 51,
    BET_STATUS_ABN: 52,
    BET_STATUS_UNK: 53,

    TEAM_HOME: 1,
    TEAM_AWAY: 2,

    SITE_SBO_ID: 1,
    SITE_IBC_ID: 3,
    SITE_SING_ID: 5,
    SITE_PINNA_ID: 10,
    SITE_ISN_ID: 11,
    SITE_ISC_ID: 16,
    SITE_BETFAIR_ID: 17,
    SITE_DATAPROVIDER_ID: 18,
    SITE_SHARPBET_ID: 19,
    SITE_3BET_ID: 21,
    SITE_PINNWEB_ID: 20,
    SITE_MATCHBOOK_ID: 22,

    DBALL_MARKET_LIVE: 1,
    DBALL_MARKET_TODAY: 2,
    DBALL_MARKET_EARLY: 3,

    FEED_SOURCE_LIVE: 1,
    FEED_SOURCE_TODAY: 2,
    FEED_SOURCE_EARLY: 3,

    DEFAULT_ODDS_TYPE_BEST: 1,
    DEFAULT_ODDS_TYPE_MEDIAN: 2,
    DEFAULT_ODDS_TYPE_LOWEST: 3,

    MEN: 1,
    WOMEN: 2,

    TEAM_MEN: 0,
    TEAM_WOMEN: 1,

    TEAM_YOUTH: 1,
    TEAM_SENIOR: 0,

    LINE_ALL: 'all',
    LINE_MAIN: 1,
    LINE_TWO: 2,
    LINE_THREE: 3,
    LINE_FOUR: 4,
    LINE_FIVE: 5,

    GAME_PERIOD_FT: 1,
    GAME_PERIOD_1H: 2,

    EVENT_PERIOD_FT: 1,
    EVENT_PERIOD_1H: 2,

    TIME_PERIOD_1H: 1,
    TIME_PERIOD_FT: 2,

    TEAMWHERE_HOME: 1,
    TEAMWHERE_AWAY: 2,
    TEAMWHERE_DRAW: 3,

    SITE_CODE: {
        1: 'SBO',
        3: 'IBC',
        5: 'SNG',
        10: 'PIN',
        11: 'ISN',
        17: 'BF',
        18: 'DP',
        19: 'SB',
        21: '3ET',
        22: 'MB',
    },

    SITE_NAME: {
        1: 'SBO',
        3: 'IBC',
        5: 'Singbet',
        10: 'Pinnacle',
        11: 'ISN',
        17: 'Betfair',
        18: 'Data Provider',
        19: 'Sharpbet',
        21: '3et',
        22: 'Matchbook',
    },

    SITE_RULES_LINK: {
        1: 'https://help.sbobet.com/article/sports-betting-rules-301.html',
        3: 'https://www.nova88.com/index_info.aspx?page=3&lang=en',
        10: 'https://www.ps3838.com/static/index.php/en/help/bettingrules#Soccer',
        11: 'http://www.isn99.com/membersite-api/cms/rules/?locale=en_US#',
        17: 'https://www.betfair.com/en/aboutUs/Rules.and.Regulations/',
        19: 'https://sharpbet.com/page/bettingrules',
        21: 'https://www.3et.com',
        22: 'https://www.matchbook.com/page/rules_and_regulations/sports-rules',
    },

    SITE_TERMS_LINK: {
        3: 'https://www.nova88.com/index_info.aspx?page=3&lang=en',
        10: 'https://www.ps3838.com/static/index.php/en/',
        17: 'https://www.betfair.com/en/aboutUs/Terms.and.Conditions/',
        21: 'https://www.3et.com',
        22: 'https://www.matchbook.com/page/rules_and_regulations/terms-and-conditions',
    },

    LIMITS_CATEGORY: {
        1: 'Pro',
        2: 'High',
        3: 'Medium',
        4: 'Low',
        5: 'Micro',
    },

    AGE_CATEGORY: {
        1: 'Senior (First team)',
        2: 'Youth (U18 to U23)',
        3: 'Kids (U17 or younger)',
    },

    GENDER_CATEGORY: {
        1: 'Men',
        2: 'Women',
    },

    TEAM_GENDER: {
        0: 'Men',
        1: 'Women',
    },

    TEAM_AGE: {
        0: 'Senior',
        1: 'Youth',
    },

    TEAM_TYPE: {
        1: 'Club',
        2: 'National',
        3: 'Fantasy',
    },

    CATEGORY: {
        1: 'International',
        2: 'Domestic League',
        6: 'International Friendly',
        8: 'Club Friendly',
        10: 'Domestic Cup',
        11: 'Club International',
    },

    CURRENCY: {
        1: '€',
        2: '£',
        3: '¥',
        4: 'R$',
        5: '$',
        6: 'RM',
        7: 'hk$',
    },

    CURRENCY_EURO_ID: 1,
    CURRENCY_BRL_ID: 4,
    CURRENCY_USD_ID: 5,

    ORDER_STATUS_OPEN_ID: 1,
    ORDER_STATUS_CLOSED_ID: 2,
    ORDER_STATUS_CLOSING_ID: 3,

    ORDER_CLOSE_REASON_NORMALLY: 1,
    ORDER_CLOSE_REASON_SCORE_CHANGED: 2,
    ORDER_CLOSE_REASON_TIMED_OUT: 3,
    ORDER_CLOSE_REASON_INSUFFICIENT_CREDIT: 4,
    ORDER_CLOSE_REASON_GAME_FINISHED: 5,
    ORDER_CLOSE_REASON_MANUALLY_CLOSED: 6,
    ORDER_CLOSE_REASON_GAME_STARTED: 7,
    ORDER_CLOSE_REASON_REJECTED_BET: 8,
    ORDER_CLOSE_REASON_ACCOUNT_BLOCKED: 9,

    ORDER_CLOSE_REASON_EXECUTED_ID: 1,

    ORDER_BETTING_STAGE_NEW_ORDER_ID: 1,
    ORDER_BETTING_STAGE_BET_ATTEMPTING_ID: 2,
    ORDER_BETTING_STAGE_WAITING_ID: 3,
    ORDER_BETTING_STAGE_LOOKING_FOR_PRICE_ID: 4,

    ORDER_STATUS: {
        1: 'Open',
        2: 'Closed',
        3: 'Closing',
    },

    TRADING_TYPE_BOT: 1,
    TRADING_TYPE_ORDER: 2,

    USER_TYPE_PLAYER_ID: 7,
    USER_TYPE_GUEST_ID: 100,

    PLATFORM_TRADEBALL: 1,
    PLATFORM_WL_BETBRA: 2,
    PLATFORM_WL_APOSTASNOW: 3,
    PLATFORM_WL_APOSTASBF: 4,
    PLATFORM_WL_DRINBETZERO: 5,
    PLATFORM_WL_BOLSADEAPOSTA: 6,
    PLATFORM_WL_GREENWIN: 7,
    PLATFORM_WL_BETBOX: 8,
    PLATFORM_WL_FULLTBET: 9,
    PLATFORM_WL_VERDINHABET: 10,
    PLATFORM_WL_ODDJUSTA: 11,

    NOTIFICATION_TYPE_INFO: 1,
    NOTIFICATION_TYPE_WARNING: 2,
    NOTIFICATION_TYPE_ERROR: 3,
    NOTIFICATION_TYPE_NOTIFICATION: 4,
    NOTIFICATION_TYPE_MESSAGE: 5,

    CUSTOM_LEAGUE_FANTASY: 1491,

    CUSTOM_TEAM_TYPE_CLUB: 1,
    CUSTOM_TEAM_TYPE_NATIONAL: 2,
    CUSTOM_TEAM_TYPE_FANTASY: 3,

    BRAZIL_COUNTRY_ID: 18,

    AGENT_VIKTOR_TB_ID: 104,

    SBOBET_ALLOWED_CUSTOM_LEAGUES_IDS: [71, 130, 88, 209, 83, 1354, 89, 1357, 1380, 1593, 2759, 2758, 66, 65, 165, 1364, 214, 58, 102, 92, 2760, 2566],
    IBCBET_ALLOWED_LIMITS_CATEGORY_IDS: [1, 2, 3],
});
export default constants;
